module.exports = __webpack_public_path__ + "static/img/矩形@2x2.4353642f.png";